<!-- <div style="width:500px;height:500px;background:#EAF4F5"> -->

<svg width="100%" height="480" style="border: 1px solid #eaeaeb;background:#EAF4F5">

  <rect *ngIf="!canDrawPipe" stroke-dasharray="5,5" [attr.id]="i" y="109" x="100" width="10" [attr.height]="250"
    class="pipe pipe-empty">
  </rect>
  <ng-container *ngIf="canDrawPipe">
    <rect *ngFor="let pipe of pipes,let i=index" [attr.id]="i" [attr.y]="109 + startYForPipe(i)" x="100" width="10"
      [attr.height]="totalPipeLength == 0 && pipes.length == 1 ? 250 : (pipes[i].length <=0 ? 0.01 : pipes[i].length) * pipeLengthRatio"
      (click)="selected($event)" [attr.class]="pipe.xdim1 <= 0 ? 'pipe-undefined' : 'pipe'">
      <title class="title">{{ pipeDescription(i) }} </title>
    </rect>
  </ng-container>

  <text *ngFor="let pipe of pipes,let i=index"
    [attr.y]="120 + startYForPipe(i) + (((pipes[i].length <=0 ? 0.01 : pipes[i].length) * pipeLengthRatio)/2)" x="130"
    class="result-text">
    {{ pipes[i].parallel > 1 ? 'x' + pipes[i].parallel : ''}}
  </text>

  <text x="50" y="120" class="result-text" style="font-size: 16px;" dominant-baseline="middle"
    text-anchor="middle">{{title}}</text>


  <text x="50" y="150"
    [attr.class]="(result[keys.systemUpstreamSpeed] && result[keys.systemUpstreamSpeed].input) || (result[labels[keys.systemUpstreamSpeed]] && result[labels[keys.systemUpstreamSpeed]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">C</text>
  <text x="50" y="170"
    [attr.class]="(result[keys.systemUpstreamSpeed] && result[keys.systemUpstreamSpeed].input) || (result[labels[keys.systemUpstreamSpeed]] && result[labels[keys.systemUpstreamSpeed]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    {{value(keys.systemConductance,quantity.SPEED)}}
  </text>
  <text x="50" y="190"
    [attr.class]="(result[keys.systemUpstreamSpeed] && result[keys.systemUpstreamSpeed].input) || (result[labels[keys.systemUpstreamSpeed]] && result[labels[keys.systemUpstreamSpeed]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    {{unit(quantity.SPEED)}}
  </text>

  <text x="50" y="240"
    [attr.class]="(result[keys.systemThroughput] && result[keys.systemThroughput].input) || (result[labels[keys.systemThroughput]] && result[labels[keys.systemThroughput]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    Q
  </text>
  <text x="50" y="260"
    [attr.class]="(result[keys.systemThroughput] && result[keys.systemThroughput].input) || (result[labels[keys.systemThroughput]] && result[labels[keys.systemThroughput]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    {{result[keys.systemThroughput]?value(keys.systemThroughput,result[keys.systemThroughput].quantity):value(keys.systemThroughput,quantity.THROUGHPUT)}}
  </text>
  <text x="50" y="280"
    [attr.class]="(result[keys.systemThroughput] && result[keys.systemThroughput].input) || (result[labels[keys.systemThroughput]] && result[labels[keys.systemThroughput]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    {{result[keys.systemThroughput]?unit(result[keys.systemThroughput].quantity):unit(quantity.THROUGHPUT)}}
  </text>

  <ng-container *ngIf="result[labels[keys.systemThroughputMassFlow]]">
    <text x="50" y="300"
      [attr.class]="(result[keys.systemThroughputMassFlow] && result[keys.systemThroughputMassFlow].input) || (result[labels[keys.systemThroughputMassFlow]] && result[labels[keys.systemThroughputMassFlow]].input)  ? 'input-text' : 'result-text'"
      dominant-baseline="middle" text-anchor="middle">
      {{value(keys.systemThroughputMassFlow,quantity.THROUGHPUT_MASS_FLOW)}}
    </text>
    <text x="50" y="320"
      [attr.class]="(result[keys.systemThroughputMassFlow] && result[keys.systemThroughputMassFlow].input) || (result[labels[keys.systemThroughputMassFlow]] && result[labels[keys.systemThroughputMassFlow]].input)  ? 'input-text' : 'result-text'"
      dominant-baseline="middle" text-anchor="middle">
      {{unit(quantity.THROUGHPUT_MASS_FLOW)}}
    </text>
  </ng-container>


  <ng-container *ngIf="result[labels[keys.systemThroughputMolarFlow]]">
    <text x="50" y="340"
      [attr.class]="(result[labels[keys.systemThroughputMolarFlow]] && result[labels[keys.systemThroughputMolarFlow]].input) || (result[labels[keys.systemThroughputMolarFlow]] && result[labels[keys.systemThroughputMolarFlow]].input)  ? 'input-text' : 'result-text'"
      dominant-baseline="middle" text-anchor="middle">
      {{value(keys.systemThroughputMolarFlow,quantity.THROUGHPUT_MOLAR_FLOW)}}
    </text>
    <text x="50" y="360"
      [attr.class]="(result[labels[keys.systemThroughputMolarFlow]] && result[labels[keys.systemThroughputMolarFlow]].input) || (result[labels[keys.systemThroughputMolarFlow]] && result[labels[keys.systemThroughputMolarFlow]].input)  ? 'input-text' : 'result-text'"
      dominant-baseline="middle" text-anchor="middle">
      {{unit(quantity.THROUGHPUT_MOLAR_FLOW)}}
    </text>
  </ng-container>

  <text x="105" y="30"
    [attr.class]="(result[keys.systemUpstreamSpeed] && result[keys.systemUpstreamSpeed].input) || (result[labels[keys.systemUpstreamSpeed]] && result[labels[keys.systemUpstreamSpeed]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    S
    {{valueWithUnit(keys.systemUpstreamSpeed,quantity.SPEED)}}
  </text>

  <text x="105" y="50"
    [attr.class]="(result[keys.systemUpstreamPressure] && result[keys.systemUpstreamPressure].input) || (result[labels[keys.systemUpstreamPressure]] && result[labels[keys.systemUpstreamPressure]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    P
    {{valueWithUnit(keys.systemUpstreamPressure,quantity.PRESSURE)}}
  </text>

  <text x="105" y="440"
    [attr.class]="(result[keys.systemDownstreamPressure] && result[keys.systemDownstreamPressure].input) || (result[labels[keys.systemDownstreamPressure]] && result[labels[keys.systemDownstreamPressure]].input)  ? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    P
    {{valueWithUnit(keys.systemDownstreamPressure,quantity.PRESSURE)}}
  </text>

  <text x="105" y="420"
    [attr.class]="(result[keys.systemDownstreamSpeed] && result[keys.systemDownstreamSpeed].input) || (result[labels[keys.systemDownstreamSpeed]] && result[labels[keys.systemDownstreamSpeed]].input)? 'input-text' : 'result-text'"
    dominant-baseline="middle" text-anchor="middle">
    S
    {{valueWithUnit(keys.systemDownstreamSpeed,quantity.SPEED)}}
  </text>

  <polygon
    *ngIf="result[labels[keys.systemDownstreamPressure]] && result[labels[keys.systemUpstreamPressure]] && (result[labels[keys.systemDownstreamPressure]].value < result[labels[keys.systemUpstreamPressure]].value)"
    points="85,70 105,90 125,70" class="arrow" />
  <polygon
    *ngIf="result[labels[keys.systemDownstreamPressure]] && result[labels[keys.systemUpstreamPressure]] && (result[labels[keys.systemDownstreamPressure]].value > result[labels[keys.systemUpstreamPressure]].value)"
    points="85,90 105,70 125,90" class="arrow" />
  <polygon
    *ngIf="result[keys.systemDownstreamPressure] && result[keys.systemUpstreamPressure] && (result[keys.systemDownstreamPressure].value < result[keys.systemUpstreamPressure].value)"
    points="85,70 105,90 125,70" class="arrow" />
  <polygon
    *ngIf="result[keys.systemDownstreamPressure] && result[keys.systemUpstreamPressure] && (result[keys.systemDownstreamPressure].value > result[keys.systemUpstreamPressure].value)"
    points="85,90 105,70 125,90" class="arrow" />

  <polygon
    *ngIf="result[labels[keys.systemDownstreamPressure]] && result[labels[keys.systemUpstreamPressure]] && (result[labels[keys.systemDownstreamPressure]].value > result[labels[keys.systemUpstreamPressure]].value)"
    points="85,400 105,380 125,400" class="arrow" />
  <polygon
    *ngIf="result[labels[keys.systemDownstreamPressure]] && result[labels[keys.systemUpstreamPressure]] && (result[labels[keys.systemDownstreamPressure]].value < result[labels[keys.systemUpstreamPressure]].value)"
    points="85,380 105,400 125,380" class="arrow" />
  <polygon
    *ngIf="result[keys.systemDownstreamPressure] && result[keys.systemUpstreamPressure] && (result[keys.systemDownstreamPressure].value > result[keys.systemUpstreamPressure].value)"
    points="85,400 105,380 125,400" class="arrow" />
  <polygon
    *ngIf="result[keys.systemDownstreamPressure] && result[keys.systemUpstreamPressure] && (result[keys.systemDownstreamPressure].value < result[keys.systemUpstreamPressure].value)"
    points="85,380 105,400 125,380" class="arrow" />


  Sorry, your browser does not support inline SVG.
</svg>

<!-- <div style="padding-top:30px">
    <app-result-table  [defaultStyle]="false" [results]="[result]" style="float:left;color:#5a7d7e;font-size: 15px;"></app-result-table>
    </div>
  </div> -->
